import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What skills do I need to learn robotics?",
   
    description:
      "Robotics requires skills in electronics, mechanical design, sensors, programming, microcontrollers, and problem-solving. As you grow, you also learn automation, AI, and control systems.",
  },
  {
    title: "What programming languages are used in robotics?",
 
    description:
      "Common languages include Python, C++, C, MATLAB, and ROS-based scripting. These languages help control robots, process data, and write algorithms for movement or automation.",
  },
  {
    title: "Where is robotics used in real life?",
   
    description:
      "Robotics is used in manufacturing, medical surgeries, defense, agriculture, space missions, warehousing, automation, self-driving vehicles, and service robots like delivery or cleaning bots.",
  },
  {
    title: "What job roles are available in robotics?",
    
    description:
      "Careers include Robotics Engineer, Automation Engineer, Embedded Engineer, Control Systems Engineer, Machine Vision Engineer, Mechatronics Engineer, and R&D Engineer.",
  },
  {
    title: "What tools and software are used in robotics?",
    
    description:
      "Robotics commonly uses Arduino IDE, ROS, MATLAB, SolidWorks, Fusion 360, Gazebo, OpenCV, and simulation tools for testing robot movement.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                <div className="category">{item.category}</div>

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
